import { Frame, SegmentationLabel } from '../../../../models/segmentation';

const exampleFrameData: Frame = {
  dicomUuid: '12d1efab-016d-4474-96dd-f2d9b8c41c5f',
  fileUrl:
    'https://storage.googleapis.com/icardio-production-api-endpoint/Frames/di-12D1-EFAB-016D/46.png?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=prod-account%40icardio-prod-project.iam.gserviceaccount.com%2F20250820%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20250820T140207Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=76018b80c3e40c688ca69730ba3db0f59489ccc0ab940619fe1dfb6945b1397e23ae48ce04e21117477bcd1fdccbc721397d738db3b52cf75aead916a72c15d8a227cf4ccccd704b9ec58fbddcb054a292d60d383672e4dc42bd7ace2f684dcbdf34b3e103c32e3b1c41761e4d6a25bedf537e4d9b69ed78031adad3891c439d9edf1d9ec74a702a5ca34dd64dd8ffbb6cc8d7cbc56c467f68ae523a6e8b5915e13250a3f0affeeeabdd6d4e684da1f7819620cca2c59c832e60616ee040ff62c4633c82f3a4509d6506becf8a3b3b638f69c70c404b7add6f66fb0e619dddb301664e8e5c5cfb1c31e2d175287c202041d2771a01414e82bcff2cc417b7e7ca',
  icid: 'fr-18DD-E921-1D1D',
  index: 46,
  segmentationLabels: [], // Frame interface requires this array
};

export const exampleSegmentations: SegmentationLabel[] = [
  {
    icid: 'se-E4EB-55A8-D336',
    uuid: 'e4eb55a8-d336-4951-a1e9-489e22e62840',
    createdAt: '2025-05-30T15:45:10.455852Z',
    datasourceName: 'ABBOTT',
    dicomIcid: 'di-12D1-EFAB-016D',
    dicomUuid: '12d1efab-016d-4474-96dd-f2d9b8c41c5f',
    frameIcid: 'fr-18DD-E921-1D1D',
    frameIndex: 46,
    frameUuid: '18dde921-1d1d-4fe0-af38-3eb86e6251cc',
    isApproved: false,
    isFullyVisible: true,
    isRejected: false,
    isReviewed: false,
    paths: [''],
    segmentationClassValue: 'Aortic Valve',
    fileUrl:
      'https://storage.googleapis.com/icardio-production-api-endpoint/Labels/Segmentations/e4eb55a8-d336-4951-a1e9-489e22e62840.png?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=prod-account%40icardio-prod-project.iam.gserviceaccount.com%2F20250820%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20250820T140207Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=3ecef81cf531611623bffdcd9ee60cbd2712686c513a0c51412f0c2d57786d5755ce197b46b0f592afd43f12ec8b1189d61e0bcc41d48c50ae2532b17488fe1702d4a974987b9d009e57fd9749075b82e5e34f1c3c5d20d3096100de8b07806b4d2f09fea319a1c4bbe28e9d02bc4dfe380ad3a9becdb89917a53044d9509e30a08cee7bfb24d108296b6d216d17c5390503c78459d01fe78b745e7c73b503320b5ea26f1bc7c7d5618617c9a9d235df94d734d381999d848a29c4a336fb9ec61e61e64aeebf4ad47af57062c48d791d49c5bfca43e80075fad325823568ca58b619592d70c94d515e99162253ed377af32a7d278e3e22693ec92150f7b5ed04',
  },
];

export const frameWithSegmentations: Frame = {
  ...exampleFrameData,
  segmentationLabels: exampleSegmentations,
};
